var _linearGradient, _path, _linearGradient2, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_41205b7dea45a30e6ba8664fa2335c639def136c5bf921e943b2085da9cc8b23",
    gradientUnits: "userSpaceOnUse",
    x1: 27.312,
    y1: 56.498,
    x2: 63.592,
    y2: 56.498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_0_41205b7dea45a30e6ba8664fa2335c639def136c5bf921e943b2085da9cc8b23)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M27.937 56.498h35.029"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_41205b7dea45a30e6ba8664fa2335c639def136c5bf921e943b2085da9cc8b23",
    gradientUnits: "userSpaceOnUse",
    x1: 5409.732,
    y1: 5391.099,
    x2: 5459.227,
    y2: 5391.099,
    gradientTransform: "rotate(90 5410.503 5.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_41205b7dea45a30e6ba8664fa2335c639def136c5bf921e943b2085da9cc8b23)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.673 5.123v48.244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.966 53.396V4.863H22.034l.028 51.365"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.966 53.395H25.167a3.114 3.114 0 00-3.105 3.105 3.114 3.114 0 003.105 3.105h37.799v-6.21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M41.09 30.004h6.328V43.852H37.129v-9.887"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M48.031 32.424h2.111V46.6l-10.29.035v-2.616M41.09 30.004l-3.961 3.961h3.961z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M31.496 12.226h24.279v6.038H31.496zM35.628 20.894h16.014v3.019H35.628z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentJournal);
export default __webpack_public_path__ + "static/media/documentJournal.0dabcaf9c8927252bfac433ebc6eb364.svg";
export { ForwardRef as ReactComponent };